import { render, staticRenderFns } from "./AddressDialog.vue?vue&type=template&id=2c5e29ba"
import script from "./AddressDialog.vue?vue&type=script&lang=js"
export * from "./AddressDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports